module.exports = __webpack_public_path__ + "static/media/ttt_q_table_only.6c012e17.png";